module.exports = __webpack_public_path__ + "img/Cover.4eeabaf3.jpg";